// 去掉json时间中的T
export function replaceTime(str) {
  let newTime = str.replace(/T/g, ' ')
  newTime = newTime.replace(/-/g, '/')
  newTime = newTime.slice(0, newTime.length - 3)
  return newTime
}

// 从REST API返回的时间字符串中提取日期
export function getDate(isoDateStr) {
  let result = isoDateStr.split("T")[0]
  result = result.replace(/-/g, '/')
  return result
}